module.exports = __webpack_public_path__ + "img/Seccion-2.5af332b0.png";